import { connect } from 'react-redux'
import MyFiles from './my-files'
import { fetchMyFiles } from '../../../../stores/my-files/my-files.actions'
import {
  getFetchMyFilesRequest,
  getMyFiles,
  getPagination
} from '../../../../stores/my-files/my-files.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => {
  const fetchMyFilesRequest = getFetchMyFilesRequest(state)
  const files = getMyFiles(state)
  const restrictedFromCreatingAFs =
    me &&
    me.account &&
    me.account.subscription_policy &&
    me.account.subscription_policy.moderation &&
    me.account.subscription_policy.moderation.create_assessment_file &&
    me.account.subscription_policy.moderation.create_assessment_file.restricted
  return {
    restrictedFromCreatingAFs,
    noFiles: files && !files.result.length,
    pending: !files || fetchMyFilesRequest.pending,
    pagination: getPagination(state)
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    return dispatch(fetchMyFiles())
  },
  onPageChange: ({ selected }) =>
    dispatch(fetchMyFiles({ page: selected })).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MyFiles)
)
